import api from "./axios";

export const getExpenseClaims = (params = {}) => api.get("/expense-claims", { params });

export const getExpenseClaim = (id) => api.get(`/expense-claims/${id}`);

export const getExpenseCounts = () => api.get("/expense-claims/counts");

export const createExpenseClaim = (body) => api.post("/expense-claims", body);

export const updateExpenseClaim = (id, body) => api.patch(`/expense-claims/${id}`, body);

export const deleteExpenseClaim = (id) => api.delete(`/expense-claims/${id}`);

export const submitExpenseClaim = (id) => api.post(`/expense-claims/${id}/submit`);

export const uploadExpenseReceipt = (id, file) => {
  const form = new FormData();
  form.append("receipt", file);
  return api.post(`/expense-claims/${id}/receipt`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const fetchExpenseReceipt = (id) =>
  api.get(`/expense-claims/${id}/receipt`, { responseType: "blob" });

export const getExpenseReceiptUrl = (id) => `/api/expense-claims/${id}/receipt`;

export const hodApproveExpense = (id, body = {}) => api.post(`/expense-claims/${id}/hod-approve`, body);

export const hodRejectExpense = (id, body) => api.post(`/expense-claims/${id}/hod-reject`, body);

export const hodReconcileExpense = (id, body) => api.post(`/expense-claims/${id}/hod-reconcile`, body);

export const saApproveExpense = (id, body = {}) => api.post(`/expense-claims/${id}/sa-approve`, body);

export const saRejectExpense = (id, body) => api.post(`/expense-claims/${id}/sa-reject`, body);

export const getExpenseSettings = () => api.get("/expense-claims/settings");

export const updateExpenseSettings = (body) => api.put("/expense-claims/settings", body);
